import React from 'react';
import { Link } from 'react-router-dom';
function Navbar() {
    return (
        <nav className='navbar navbar-expand-lg navbar-dark bg-dark fixed-top'>
            <div className='container-fluid'>
                <Link className='navbar-brand' to='/'>
                    News Padho
                </Link>

                <button
                    className='navbar-toggler'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#navbarSupportedContent'
                    aria-controls='navbarSupportedContent'
                    aria-expanded='false'
                    aria-label='Toggle navigation'
                >
                    <span className='navbar-toggler-icon'></span>
                </button>
                <div
                    className='collapse navbar-collapse'
                    id='navbarSupportedContent'
                >
                    <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
                        <li className='nav-item'>
                            <Link
                                className='nav-link'
                                aria-current='page'
                                to='/business'
                            >
                                Business
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                className='nav-link'
                                aria-current='page'
                                to='/entertainment'
                            >
                                Entertainment
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                className='nav-link'
                                aria-current='page'
                                to='/general'
                            >
                                General
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                className='nav-link'
                                aria-current='page'
                                to='/health'
                            >
                                Health
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                className='nav-link'
                                aria-current='page'
                                to='/science'
                            >
                                Science
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                className='nav-link'
                                aria-current='page'
                                to='/sports'
                            >
                                Sports
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                className='nav-link'
                                aria-current='page'
                                to='/technology'
                            >
                                Technology
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                className='nav-link'
                                aria-current='page'
                                to='/country'
                            >
                                Country
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                className='nav-link'
                                aria-current='page'
                                to='/sources'
                            >
                                Sources
                            </Link>
                        </li>
                        <li className='nav-item dropdown'>
                            <Link
                                className='nav-link dropdown-toggle'
                                to='/'
                                id='navbarDropdown'
                                role='button'
                                data-bs-toggle='dropdown'
                                aria-expanded='false'
                            >
                                News Portals
                            </Link>
                            <ul
                                className='dropdown-menu'
                                aria-labelledby='navbarDropdown'
                            >
                                <li>
                                    <Link
                                        className='dropdown-item'
                                        to='/newsportal/bbc'
                                    >
                                        BBC News
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className='dropdown-item'
                                        to='/newsportal/cnn'
                                    >
                                        CNN
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className='dropdown-item'
                                        to='/newsportal/fox'
                                    >
                                        Fox News
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className='dropdown-item'
                                        to='/newsportal/google'
                                    >
                                        Google News
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}
export default Navbar;